import {CHANGE_LOADING} from './constants';

export const setLoading = (val) => ({
  type: CHANGE_LOADING,
  payload: val
});

export const changeLoading = (val) => (dispatch) => dispatch(setLoading(val));
